import React, { useState, useEffect, useMemo }  from 'react';
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import Switch from '@mui/material/Switch';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import jQuery from 'jquery';

import { useMsal, useAccount } from "@azure/msal-react";
import { protectedResources } from "../config/authConfig";
import CONFIG from '../config';

import * as Utils from '../lib/utils';

window.jQuery = jQuery;
require("jsgrid");
                

//nested data is ok, see accessorKeys in ColumnDef below  
const Employee = (props) => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [showPrivateData, setShowPrivateData] = useState(false);
    const [employeeData, setEmployeeData] = useState(null);
    const [managersData, setManagersData] = useState(null);
    const [directReportsData, setDirectReportsData] = useState(null);
    const [closedAdjustmentsData, setClosedAdjustmentsData] = useState({});

    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    const urlParams = Utils.getParams();

    const isNotProd = CONFIG.debug || CONFIG.staging;
    const impUser = isNotProd ? localStorage.getItem("impersonated_user") : "";

    let accountUserEmail = isNotProd && impUser ? impUser : accounts[0].username; 
    let employeeId = props.userAccount && props.userAccount.id ? props.userAccount.id : null;
    let employeeHrisId = props.userAccount && props.userAccount.employee_hris_id ? props.userAccount.employee_hris_id : null;
    // console.log(props.userAccount)
    // console.log(urlParams)

    const isAdmin =
        props &&
        props.userAccount &&
        props.userAccount.access_level &&
        props.userAccount.access_level.indexOf("ADMIN") > -1;
    const isModerator =
        props &&
        props.userAccount &&
        props.userAccount.access_level &&
        props.userAccount.access_level.indexOf("MODERATOR") > -1;

    let overrideEmail = "";
    if(
        (isAdmin || isModerator)
        && (
            urlParams.accountEmail 
            && urlParams.employeeId
            && urlParams.employeeHrisId
        )
    ){
        overrideEmail = urlParams.accountEmail; 
        employeeId = urlParams.employeeId;
        employeeHrisId = urlParams.employeeHrisId;
    }

    useEffect(() => {
        if(employeeId){
            const fetchData = async () => {
                if (!employeeData || !managersData || !directReportsData) {
                    setIsLoading(true);
                } else {
                    setIsRefetching(true);
                }

                try {
                    const jsonEmployeeResponse = await Utils.getData(
                        ('/api/dashboard/manager/self?viewer_email=' + accountUserEmail + "&override_email="+overrideEmail), 
                        instance, 
                        account
                    );

                    const jsonManagersResponse = await Utils.getData(
                        ('/api/employee/' + employeeId + '/managers'), 
                        instance, 
                        account
                    );

                    const jsonReportsResponse = await Utils.getData(
                        ('/api/employee/' + employeeId + '/reportsRecrusive'), 
                        instance, 
                        account
                    );

                    const jsonClosedAdjustmentsResponse = await Utils.getData(
                        "/api/closed?managerId=" + employeeId,
                        instance,
                        account
                    );

                    setEmployeeData(jsonEmployeeResponse);
                    setManagersData(jsonManagersResponse);
                    setDirectReportsData(jsonReportsResponse);
                    setClosedAdjustmentsData(jsonClosedAdjustmentsResponse);

                } catch (error) {
                    setIsError(true);
                    console.error(error);
                    return;
                }

                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            };
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const renderHiddenIcon = ()=>{
        return <VisibilityOff
            className="saveLayoutButton"
            sx={{ color: "#000000ff", cursor: "pointer", height: "20px" }}
            title={"Toggle \"Show private data\" to view"}
        />
    }

    let orgHeiarchy = [];
    let nextId = 0;

    //get managers from CEO down
    // console.log("managersData", managersData);

    const renderEmployeeName = (userText, employee, loggedInUser)=>{
        return userText;    
    }
    // console.log("props", props);

    if(managersData && managersData.length){
        for(var i=0;i<managersData.length;i++){
            const thisUser = managersData.find((element)=>{ return element.manager_hris_id === nextId });
            // console.log("thisUser", thisUser, "managersData", managersData)
            
            orgHeiarchy.push(
                <div className="managersNode" key={Utils.guid()}>
                    <div className={"managerDetails" + (i===managersData.length-1 ? " bold" : "")}>
                        { 
                        renderEmployeeName(
                            (
                            Utils.decodeHTML(thisUser.first_name) + " " + 
                            Utils.decodeHTML(thisUser.last_name)
                            ),
                            thisUser,
                            props && props.userAccount ? props.userAccount : {}
                        ) 
                        }
                    </div>
                    {(i !== managersData.length-1 || (directReportsData && directReportsData.length) ? (<div> --&gt;</div>) : "")}
                </div>
            );
            nextId = thisUser.employee_hris_id;
        }    
    }

    // console.log("employeeData", employeeData);
    // const dateOfHireObject = employeeData && employeeData.date_of_hire ? new Date(employeeData.date_of_hire) : new Date();
    const baseDOHString = employeeData && employeeData.date_of_hire ? employeeData.date_of_hire.substring(0,10) : ""; //Utils.maskDateAs("mdy", dateOfHireObject);
    const dateOfHireString = baseDOHString ? baseDOHString.substring(5,7) + "/" + 
    baseDOHString.substring(8,10) + "/" + 
    baseDOHString.substring(0,4) : "";

    const calcuatedRangePlacement = (e)=>{
        //calculate the base salary
        //const baseSalary = ?
        //calculate the ft_annualized_salary
        //const ftAnnualizedSalary = ?
        const selectedSalary = e._calced_base_salary && parseInt(e._calced_base_salary) ? e._calced_base_salary : 
            e._calced_ft_annualized_salary_inc_premium;
        const placementPercent = 100 * 
            (
                (parseInt(selectedSalary) - parseInt(e.minimum)) / 
                (parseInt(e.maximum) - parseInt(e.minimum))
            );
        // console.log("placementPercent", placementPercent)
        return Math.round(placementPercent);
    }

    const triggerLink = (linkId) => {
        instance
            .acquireTokenSilent({
                scopes: protectedResources["apiCompensation"].scopes,
                account: account,
            })
            .then((msalAuthorization) => {
                console.log("ACCESSING LINK:", linkId, document.getElementById(linkId));
                //add the token
                const selectedLink =
                    document.getElementById(linkId).href +
                    "&token=" +
                    (msalAuthorization ? msalAuthorization.accessToken : "");

                //set the link handler
                document.getElementById("linkHandler").href = selectedLink;
                //click the link
                document.getElementById("linkHandler").click();
            });
    };

    const lastAvailableYear = directReportsData && directReportsData.length && directReportsData[0].period_start ? 
        directReportsData[0].period_start.substring(0,4) : 
        "N/A";

    // console.log("lastAvailableYear",lastAvailableYear)

    const columns = useMemo(
        //column definitions...
        () => [
            {
                accessorFn: (row) => <a href={"/employee?id=" + row.id}>{row.first_name} {row.last_name}</a>,
                header: 'Name',
                size: 100
            },
            {
                accessorKey: 'employee_hris_id',
                header: 'Employee ID',
                Header: ({ column }) => ( // Custom JSX component
                    <span>Employee <br />ID</span>
                ),
                size: 120
            },
            {
                accessorKey: 'position_title',
                header: 'Position',
                size: 140
            },
            {
                accessorFn: (row) => <span>{row.manager_first_name} {row.manager_last_name}</span>,
                header: 'Supervisor',
                size: 140,
                sortingFn: (a, b, columnId) => {
                    const managerNameA = (a.original.manager_first_name+" "+a.original.manager_last_name);
                    const managerNameB = (b.original.manager_first_name+" "+b.original.manager_last_name);
                    if (managerNameA < managerNameB) {
                        return -1;
                    }else if (managerNameA > managerNameB) {
                        return 1;
                    }
                    return 0;
                }
            },
            {
                accessorKey: 'hours_week',
                header: 'Hours/Week',
                Header: ({ column }) => ( // Custom JSX component
                    <span>Hours/<br />Week</span>
                ),
                size: 110,
                sortingFn: Utils.sortTableByNumeric
            },
            {
                accessorFn: (row) => `${Utils.moneyMask(Utils.roundTo(row.hours_week * 52 * row.current_hourly_rate, 1))}`,
                header: 'PT pro-rated (with premium) salary',
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            (a.original.hours_week * 52 * a.original.current_hourly_rate),
                            (b.original.hours_week * 52 * b.original.current_hourly_rate)
                        );
                    }else{
                        return 0;
                    }
                },
                Cell: ({ cell, row }) => {
                    return <span>{showPrivateData ? `${Utils.moneyMask(Utils.roundTo(row.original.hours_week * 52 * row.original.current_hourly_rate,1))}` : renderHiddenIcon()}</span>
                }
            },
            {
                accessorFn: (row)=> row._calced_base_salary && parseInt(row._calced_base_salary) ? Utils.moneyMask(Utils.roundTo(row._calced_base_salary,1)) : "",
                header: 'Base Salary',
                Header: ({ column }) => ( // Custom JSX component
                    <span>Base <br />Salary</span>
                ),
                size: 100,
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{row.original._calced_base_salary && parseInt(row.original._calced_base_salary) ? Utils.moneyMask(Utils.roundTo(row.original._calced_base_salary,1)) : ""}</span> : renderHiddenIcon();
                },
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            (a.original._calced_base_salary && parseInt(a.original._calced_base_salary) ? parseInt(a.original._calced_base_salary) : 0),
                            (b.original._calced_base_salary && parseInt(b.original._calced_base_salary) ? parseInt(b.original._calced_base_salary) : 0)
                        );
                    }else{
                        return 0;
                    }
                }
            },
            {
                accessorFn: (row)=> row.manager_premium && parseInt(row.manager_premium) ? (row.manager_premium + "%") : "",
                header: 'Manager Premium',
                Header: ({ column }) => ( // Custom JSX component
                    <span>Manager <br />Premium</span>
                ),
                size: 140,
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{row.original.manager_premium && parseInt(row.original.manager_premium) ? (row.original.manager_premium + "%") : ""}</span> : renderHiddenIcon();
                },
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            a.original.manager_premium,
                            b.original.manager_premium
                        );
                    }else{
                        return 0;
                    }
                }
            },
            {
                accessorFn: (row)=> row._calced_ft_annualized_salary_inc_premium,
                header: 'FT Annaulized Salary (Rounded)',
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{Utils.moneyMask(Utils.roundTo(row.original._calced_ft_annualized_salary_inc_premium, 1))}</span> : renderHiddenIcon();
                },
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            a.original._calced_ft_annualized_salary_inc_premium,
                            b.original._calced_ft_annualized_salary_inc_premium
                        );
                    }else{
                        
                    }
                }
            },
            {
                accessorFn: (row)=>row.group_name,
                header: 'Salary Group',
                size: 140,
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        if (a.original.group_name < b.original.group_name) {
                            return -1;
                        }else if (a.original.group_name > b.original.group_name) {
                            return 1;
                        }
                    }
                    return 0;
                },
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{row.original.group_name}</span> : renderHiddenIcon();
                }
            },
            {
                accessorFn: (row)=>row.current_hourly_rate,
                header: 'Hourly Rate',
                size: 140,
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            a.original.current_hourly_rate,
                            b.original.current_hourly_rate
                        );
                    }
                },
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{`${Utils.moneyMask(row.original.current_hourly_rate, 2)}`}</span> : renderHiddenIcon();
                }
            },
            {
                accessorFn: (row)=>calcuatedRangePlacement(row),
                header: 'Range Placement',
                size: 180,
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            calcuatedRangePlacement(a.original),
                            calcuatedRangePlacement(b.original)
                        );
                    }else{
                        return 0;
                    }
                },
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>{calcuatedRangePlacement(row.original)}%</span> : renderHiddenIcon();
                }
            },
            {
                accessorFn: (row)=>row.minimum,
                header: 'Salary Range',
                Header: ({ column }) => ( // Custom JSX component
                    <span>Salary Range ({lastAvailableYear})</span>
                ),                
                sortingFn: (a, b, columnId) => {
                    if(showPrivateData){
                        return Utils.sortTableByNumeric(
                            a.original.minimum,
                            b.original.minimum
                        );
                    }else{
                        return 0;
                    }
                },
                Cell: ({ cell, row }) => {
                    return showPrivateData ? <span>${row.original.minimum} - ${row.original.midpoint} - ${row.original.maximum}</span> : renderHiddenIcon();
                }
            },
        ],
        [showPrivateData, directReportsData]
    );

    const directReportsTable = useMaterialReactTable({
        columns,
        data: (directReportsData ? directReportsData : []), //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableKeyboardShortcuts: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: true,
        enableTopToolbar: false,
        // enableBottomToolbar: (directReportsData && directReportsData.length > 10), //if we have paging, use this
        enableBottomToolbar: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: theme.palette.background.default, //change default background color
        }),
        muiTableBodyRowProps: { hover: false },
        muiTableProps: {
            sx: {
                border: '1px solid rgba(81, 81, 81, .5)',
                caption: {
                    captionSide: 'top',
                },
            },
        },
        muiTableHeadCellProps: {
            sx: {
                bgcolor: '#007998',
                borderTop: '1px solid #dddddd',
                color: '#FFF',
                // fontStyle: 'italic',
                fontWeight: 'bold',
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderTop: '1px solid #dddddd',
            },
        }
    });

    return employeeData && employeeData.result === "UNAUTHORIZED" ? 
        <div>Unauthorized</div> :
        (
            !isLoading && employeeData ? 
            (<div className="managerDashboardBody">
                <div className={"privateDataToggleContainer"}>
                    <Switch
                        checked={showPrivateData}
                        onClick={(e)=>{
                            e.preventDefault();
                            setShowPrivateData(!showPrivateData);
                            return false;
                        }}
                    /> Show private data
                </div>
                <div className={"header"}>Manager Dashboard</div>
                <div>&nbsp;</div> 
                <div><b>Employee Name:</b> {Utils.decodeHTML(employeeData.first_name)} {Utils.decodeHTML(employeeData.last_name)}</div>
                <div><b>Employee HRIS ID:</b> {employeeData.employee_hris_id}</div>
                <div><b>Position Title:</b> {employeeData.position_title}</div>
                <div><b>Location:</b> {employeeData.location === "Remote" ? employeeData.remote_city : employeeData.location}, {employeeData.resident_state}</div>
                <div><b>Date of Hire:</b> {dateOfHireString}</div>
                <div><b>My Annualized Salary:</b> {showPrivateData ? Utils.moneyMask(employeeData.current_ft_annualized_salary) : renderHiddenIcon()}</div>

                <div>&nbsp;</div>

                <strong><a href={"/salaryDisplay"}>
                    View Salary Ranges
                </a></strong>
                
                <div>&nbsp;</div>

                {employeeHrisId && directReportsData.length ? <div><a style={{fontWeight:"bold"}} href={"/compensation?managerHrisId="+employeeHrisId}>Go to current compensation page</a></div> : null}

                <div>&nbsp;</div>

                {directReportsData.length ? 
                    <div>
                        <div><b>Direct Reports:</b></div>
                        <div className="directReportsInfoDownload">
                            <a 
                                id="directReportsDownload"
                                href={
                                    CONFIG.API_HOST +
                                    "/api/employee/"+employeeId+"/reportsRecrusive?&f=xl&d=true"
                                }
                                onClick={(event) => {
                                    event.preventDefault();
                                    triggerLink("directReportsDownload");
                                    return false;
                                }}                    
                            >
                                Download Data
                            </a>
                        </div>

                        <MaterialReactTable table={directReportsTable} />
                    </div> : null
                }
                        
                <div>&nbsp;</div>
                <div><strong>Past compensation cycles</strong></div>

                {directReportsData.length && employeeHrisId ? closedAdjustmentsData.map((adjustmentItem)=>{
                    return <div key={Utils.guid()}><a href={"/compensation?status=closed&managerHrisId="+employeeHrisId+"&effectiveDate=" + adjustmentItem.effective_date}>
                        {adjustmentItem.effective_date}
                    </a></div>;
                }) : "Not Available"}

                <a href="#" id="linkHandler" style={{ visibility:"hidden" }}></a>
            </div>) : <div>Loading...</div>
        );
};

export default Employee;